import { render, staticRenderFns } from "./barchart.vue?vue&type=template&id=5a3d2cc8&scoped=true&"
import script from "./barchart.vue?vue&type=script&lang=ts&"
export * from "./barchart.vue?vue&type=script&lang=ts&"
import style0 from "./barchart.vue?vue&type=style&index=0&id=5a3d2cc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3d2cc8",
  null
  
)

export default component.exports